import { Box, IconButton, Stack, Typography } from '@mui/material';
import { IChatSession } from 'src/@types/chat';
import { Iconify } from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { FormatTime } from 'src/utils/formatTime';
import { useActionBarState } from '../ActionsBar/useActionBarState';
import { useGatheringChatState } from './gatheringChatState';
import { SessionItemHeader } from './styles';

export const PastSessionItemHeader = ({
  session,
  handleClose,
}: { session: IChatSession; handleClose?: () => void }) => {
  const { translate } = useLocales();

  const { setSessionId, addChatSessionToList } = useGatheringChatState();
  const { setOpenAction } = useActionBarState();

  const handleOpenChat = () => {
    if (!session.active) {
      addChatSessionToList(session);
    }
    setSessionId(session._id);
    setOpenAction('gatheringChat');
    handleClose?.();
  };

  return (
    <SessionItemHeader>
      <Stack direction="row" justifyContent="space-between" gap={3}>
        <Stack>
          <Stack direction="row" alignItems="center" gap={1}>
            <Iconify icon="tabler:calendar-stats" color="text.secondary" />
            <Typography variant="subtitle1">
              {FormatTime.Date(session.startAt, 'PPPP')}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={1} ml={3} pl={0.5}>
            <Typography variant="caption" color="text.secondary">
              {translate('communicate.session_time', {
                startTime: FormatTime.Date(session.startAt, 'p'),
                endTime: FormatTime.Date(session.endAt, 'p'),
              })}
            </Typography>
          </Stack>
        </Stack>
        {session.hasChat && (
          <Box>
            <IconButton onClick={() => handleOpenChat()}>
              <Iconify icon="tabler:message" />
            </IconButton>
          </Box>
        )}
      </Stack>
    </SessionItemHeader>
  );
};
